import * as React from "react";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

export default function DeviceDropDown({
  setStatus,
  status,
}: any) {
  const handleChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <FormControl fullWidth>
        <InputLabel
          id="device-status-select-label"
          sx={{
            color: "rgb(var(--text-muted))",

            fontSize: "14px",

            "&.Mui-focused": {
              color: "rgb(var(--color-gold-1))",
            },
          }}
        >
          Select Status
        </InputLabel>

        <Select
          labelId="device-status-select-label"
          id="device-status-select"
          value={status}
          label="Select Status"
          onChange={handleChange}
          MenuProps={{
            PaperProps: {
              sx: {
                marginTop: "8px",
                borderRadius: "18px",
                overflow: "hidden",
                background:
                  "rgb(var(--surface-1))",
                border:
                  "1px solid rgb(var(--border-primary))",
                boxShadow:
                  "var(--shadow-card-hover)",
                backdropFilter: "blur(18px)",
                "& .MuiMenuItem-root": {
                  minHeight: "44px",
                  fontSize: "13px",
                  color:
                    "rgb(var(--text-primary))",
                  transition:
                    "all 0.2s ease",
                  margin: "4px 8px",
                  borderRadius: "12px",
                  "&:hover": {
                    background:
                      "rgba(var(--color-gold-1),0.08)",
                  },
                  "&.Mui-selected": {
                    background:
                      "rgba(var(--color-gold-1),0.12)",
                    color:
                      "rgb(var(--color-gold-1))",

                    fontWeight: 600,
                  },
                  "&.Mui-selected:hover": {
                    background:
                      "rgba(var(--color-gold-1),0.16)",
                  },
                },
              },
            },
          }}
          sx={{
            height: "52px",
            borderRadius: "18px",
            background:
              "rgb(var(--surface-2))",
            color:
              "rgb(var(--text-primary))",
            transition: "all 0.25s ease",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor:
                "rgb(var(--border-primary))",
            },
            "&:hover .MuiOutlinedInput-notchedOutline":
              {
                borderColor:
                  "rgba(var(--color-gold-1),0.35)",
              },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                borderColor:
                  "rgba(var(--color-gold-1),0.45)",
                boxShadow:
                  "0 0 0 4px rgba(var(--color-gold-1),0.08)",
              },
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
              color:
                "rgb(var(--text-primary))",
            },
            "& .MuiSvgIcon-root": {
              color:
                "rgb(var(--text-secondary))",
            },
          }}
        >
          <MenuItem value={"All Status"}>
            All Status
          </MenuItem>

          <MenuItem value={"Pending"}>
            Pending
          </MenuItem>

          <MenuItem value={"Solved"}>
            Solved
          </MenuItem>

          <MenuItem value={"Unsolved"}>
            Unsolved
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}